/* ELVYNECO — bouton « Ajouter au panier · PRIX PRIX-BARRÉ → » (global, tous produits). Fichier du thème : assets/elv-atc.js
 * Affichage uniquement : ne modifie ni le formulaire, ni la variante, ni le plan, ni le clic.
 * Prix lus dans cet ordre (jamais saisis en dur) :
 *   0) l'offre sélectionnée d'un sélecteur d'offres PF ([data-pfos], Scalp) : source unique carte / CTA / quantité ;
 *   1) l'offre sélectionnée d'un bundle Moonbundle (abonnement / achat unique, 1× / 3× / 5×) ;
 *   2) sinon le prix affiché par le thème (prix courant + prix barré compare-at s'il existe).
 * Pas de prix barré affiché s'il n'existe pas. Flèche : icône "arrow" de snippets/elv-cart-config.liquid.
 * Texte : clé de traduction elv.add_to_cart. Activé seulement si cette clé et l'icône existent.
 */
(function () {
  if (window.__elvAtcGlobal) return; window.__elvAtcGlobal = true;
  var dec = document.createElement('textarea');
  function T(k) { var d = window.ELV_I18N; if (!d || typeof d[k] !== 'string' || !d[k]) return null; dec.innerHTML = d[k]; return dec.value; }
  var CSS = [
    'button.product-form__submit[data-elv-atc]{font-size:0!important;position:relative;min-height:50px;background:#4B7C59!important;color:#fff!important}',
    'button.product-form__submit[data-elv-atc]>span:not(.elv-atc){display:none!important}',
    '.elv-atc{display:flex;align-items:center;justify-content:center;gap:8px;padding:0 34px;font-size:16px;font-weight:700;line-height:1.2;white-space:nowrap;max-width:100%}',
    '.elv-atc .elv-atc-p{font-size:18px;font-weight:800}',
    '.elv-atc .elv-atc-o{font-size:13px;font-weight:400;text-decoration:line-through;opacity:.65}',
    '.elv-atc .elv-atc-a{position:absolute;right:16px;top:50%;width:20px;height:20px;margin-top:-10px;display:inline-flex}',
    '.elv-atc .elv-atc-a svg,.elv-atc .elv-atc-a img{width:100%;height:100%;display:block}',
    '@media (max-width:400px){.elv-atc{font-size:14px;letter-spacing:.1px;gap:5px;padding:0 30px 0 12px}.elv-atc .elv-atc-p{font-size:16px}.elv-atc .elv-atc-o{font-size:12px}}',
    '@media (max-width:345px){.elv-atc{font-size:12.5px;padding:0 28px 0 6px}.elv-atc .elv-atc-p{font-size:14.5px}.elv-atc .elv-atc-o{font-size:11px}}'
  ].join('\n');
  function txt(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function arrowHtml() {
    var c = window.ELV_CART_CONFIG, v = c && c.icons && c.icons.arrow; if (!v) return '';
    v = String(v).trim();
    if (/^<svg[\s>]/i.test(v)) return v;
    if (/^(https?:)?\/\//i.test(v) || v.charAt(0) === '/') return '<img src="' + v.replace(/"/g, '&quot;') + '" alt="">';
    return '';
  }
  function prices() {
    var po = document.querySelector('[data-pfos][data-cur]');
    if (po && po.getAttribute('data-cur')) return { cur: po.getAttribute('data-cur'), old: po.getAttribute('data-old') || '' };
    var box = document.querySelector('.moonbundle-box');
    var act = box && box.querySelector('.moonbundle-option.moonbundle-option-active');
    if (act) {
      var cur = txt(act.querySelector('.moonbundle-option-single-price')), old = txt(act.querySelector('.moonbundle-option-old-price'));
      if (cur) return { cur: cur, old: old };
    }
    var btn = document.querySelector('button.product-form__submit');
    var root = (btn && btn.closest('section, product-info, .product')) || document;
    var p = root.querySelector('.price'); if (!p) return null;
    if (p.classList.contains('price--on-sale')) {
      var sale = p.querySelector('.price__sale .price-item--sale'), comp = p.querySelector('.price__sale .price-item--regular');
      if (sale && txt(sale)) return { cur: txt(sale), old: txt(comp) };
    }
    var reg = p.querySelector('.price__regular .price-item--regular') || p.querySelector('.price-item--regular');
    return reg && txt(reg) ? { cur: txt(reg), old: '' } : null;
  }
  function apply() {
    var label = T('add_to_cart'); if (!label) return;
    var arrow = arrowHtml(); if (!arrow) return;
    var P = prices(); if (!P) return;
    var cur = P.cur, old = P.old === P.cur ? '' : P.old;
    if (!document.getElementById('elv-atc-css')) { var st = document.createElement('style'); st.id = 'elv-atc-css'; st.textContent = CSS; document.head.appendChild(st); }
    document.querySelectorAll('button.product-form__submit').forEach(function (b) {
      if (b.disabled || b.getAttribute('aria-disabled') === 'true') { b.removeAttribute('data-elv-atc'); var x = b.querySelector('.elv-atc'); if (x) x.remove(); return; }
      var key = label + '|' + cur + '|' + old + '|' + arrow.length, c = b.querySelector('.elv-atc');
      if (c && c.getAttribute('data-k') === key) { if (b.getAttribute('data-elv-atc') !== '1') b.setAttribute('data-elv-atc', '1'); return; }
      if (!c) { c = document.createElement('span'); c.className = 'elv-atc'; b.insertBefore(c, b.firstChild); }
      c.setAttribute('data-k', key);
      c.innerHTML = '<span class="elv-atc-l"></span><span class="elv-atc-d">·</span><span class="elv-atc-p"></span>' + (old ? '<span class="elv-atc-o"></span>' : '') + '<span class="elv-atc-a" aria-hidden="true">' + arrow + '</span>';
      c.querySelector('.elv-atc-l').textContent = label;
      c.querySelector('.elv-atc-p').textContent = cur;
      if (old) c.querySelector('.elv-atc-o').textContent = old;
      b.setAttribute('data-elv-atc', '1');
    });
  }
  var mo = null, sched = null;
  function schedule() { clearTimeout(sched); sched = setTimeout(function () { try { apply(); } catch (e) {} if (mo) mo.takeRecords(); }, 60); }
  window.addEventListener('pfos:change', function () { clearTimeout(sched); sched = setTimeout(function () { try { apply(); } catch (e) {} }, 0); });
  function init() {
    var b = document.querySelector('button.product-form__submit');
    if (!b) { setTimeout(init, 800); return; }
    mo = new MutationObserver(schedule);
    var scope = b.closest('section, product-info, .product') || document.body;
    mo.observe(scope, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'disabled'] });
    setInterval(schedule, 900);
    schedule();
  }
  init();
})();
